<template>
    <div>
        <v-form @submit="onSubmitCarrierService">
            <v-container fluid>
                <v-row>
                    <v-col>
                        <v-select
                            :items="carriers"
                            v-model="selectedCarrier"
                            label="Select Carrier"
                            dense
                            outlined>
                        </v-select>
                    </v-col>
                    <v-col>
                        <v-select
                            :items="services"
                            v-model="selectedService"
                            label="Select Service"
                            dense
                            outlined
                            v-if="!selectedAddAll">
                        </v-select>
                    </v-col>
                    <v-col class="text-right">
                        <v-btn
                            small
                            :disabled="!selectedCarrier || !selectedCarrier.name || !services  || (services.length <= 0 && !selectedAddAll)"
                            type="button"
                            color="red"
                            dark
                            @click="onDeleteByCarrierGroup"
                        >Remove Carrier</v-btn>

                        <v-btn
                            small
                            type="submit"
                            color="primary"
                            :disabled="!selectedCarrier || !services || (services.length <= 0 && !selectedAddAll)">
                            <span v-if="!selectedAddAll">
                                Add Carrier / Service
                            </span>
                            <span v-else>
                                Add All Carrier & Services
                            </span>
                        </v-btn>
                        <v-tooltip
                            bottom
                            :max-width="300">
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    class="ml-1"
                                    icon
                                    v-on="on"
                                    type="button"
                                    color="secondary"
                                    :disabled="isRefreshing"
                                    @click="onRefresh">
                                    <v-progress-circular
                                        v-if="isRefreshing"
                                        indeterminate
                                        color="secondary">
                                    </v-progress-circular>
                                    <v-icon v-else>mdi-refresh-circle</v-icon>
                                </v-btn>
                            </template>
                            <span>This button will refresh carrier and services.</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>

        <v-simple-table v-if="carrierServices !== null && carrierServices.length">
            <template v-slot:default>
                <thead>
                    <tr>
                        <th>Carrier</th>
                        <th>Service</th>
                        <th width="100" class="text-center">ACTION</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(carrier, index) in carrierServices" :key="'key' + carrier.id">
                        <td>{{ carrier.name }}</td>
                        <td>{{ carrier.service }}</td>
                        <td class="text-center">
                            <v-btn color="red" dark x-small @click="()=> { onDelete(index)  }" >remove</v-btn>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
        <v-container fluid v-else>
            <v-row>
                <v-col>
                    <p class="text-center">Quoting all available carriers</p>
                </v-col>
            </v-row>
        </v-container>
        <Modal
            ref="modal"
            color="error"
            okText="delete" />
    </div>
</template>

<script>
import { EventBus } from '../../../../event-bus'
import Modal from '../../../Modal'

export default {

    components: {
        Modal
    },

    props: {
        integrationId: { type: Number, default: null },
        carrierGroupId: { type: String, default: null }
    },

    data() {
        return {
            carrierServices: null,
            carriers: [],
            services: [],
            selectedCarrier: null,
            selectedService: null,

            selectedAddAll: false,

            isRefreshing: false
        }
    },

    watch: {
        integrationId(to, from) {
            if (to != from) {
                this.selectedCarrier = null
                this.fetchCarriers()
            }
        },

        selectedCarrier(to, from) {
            if (to != from) {
                this.fetchCarrierServices()
            }
        },

        selectedService(to, from) {
            if (to != from) {
                // nothing to do here
            }
        },

        carrierGroupId(to, from) {
            if (to != from) {
                this.fetchGroupCarrierServices()
            }
        }
    },

    mounted() {

        this.fetchCarriers()
        this.fetchGroupCarrierServices()

    },

    methods: {
        async fetchCarriers() {

            try {
                let res = await this.$http.get('/api/machship/carriers', {
                    params: { integration_id: this.integrationId }
                })

                if (!res || !res.status ) {
                    console.log("[CARRIER_GROUP_SERVICES] unable to get carrier result", res);
                    return;
                }

                const { result } = res.data;
                this.carriers = result.map(carrier => {
                    return {
                        value: carrier,
                        text: carrier.name
                    }
                })

                this.carriers.unshift({
                    value: "ALL",
                    text: "ADD ALL CARRIER & SERVICES"
                })
            } catch (error) {
                EventBus.$emit('show-error', "Unable to fetch carrier and its services of " + this.integrationLabel)
                console.log("[CARRIER_GROUP_SERVICES] error", error);
                this.carriers = []
            }
        },

        fetchCarrierServices() {
            this.selectedAddAll = this.selectedCarrier == 'ALL' ? true : false
            if (this.selectedAddAll) {
                this.selectedService = null
            }

            if (!this.selectedCarrier || !this.selectedCarrier.carrierAccounts) {
                return
            }

            const { carrierAccounts } = this.selectedCarrier;
            let tempServices = [];

            carrierAccounts.forEach(account => {

                let tempAccServices = account.carrierServices
                    .filter(cservice => !/hourly/i.test(cservice.name))
                    .map(cservice => ({
                    value: cservice,
                    text: cservice.name
                }))
                // collect all services from multi array and append them to our temp variable
                tempServices = [...tempServices, ...tempAccServices];
            })
            tempServices.sort((a, b) => a.text - b.text ); // sort them by name
            this.services = tempServices;
        },

        fetchGroupCarrierServices() {
            this.$http
                .get('/api/carrier-services/' + this.carrierGroupId)
                .then(({ data }) => {
                    if (data && data.length > 0) {
                        this.carrierServices = data
                        .map(item => {
                            return {
                                name: item.carrier_name,
                                service: item.service_name,
                                id: item.id
                            }
                        })
                    } else {
                        this.carrierServices = [];
                    }
                })
                .catch(err => {
                    console.log("[LIVERATES][CARRIER_SERVICES] error", err);
                })
        },

        onSubmitCarrierService(e) {
            e.preventDefault()

            // single create of carrier service
            if (this.selectedService) {
                this.$http
                    .post('/api/carrier-services/save', {
                        integration_id: this.integrationId,
                        carrier_id: this.selectedCarrier.id,
                        service_id: this.selectedService.id,
                        service_name: this.selectedService.name,
                        carrier_name: this.selectedCarrier.name,
                        liverates_carrier_group_id: this.carrierGroupId,
                    })
                    .then(({ data }) => {
                        EventBus.$emit('show-success', "Successfully Added new carrier services")
                        this.fetchGroupCarrierServices()
                    })
                    .catch(err => {
                        EventBus.$emit('show-error', err)
                    })


            // create carrier service bulk
            } else {

                if (!this.selectedAddAll) {

                    this.$http
                        .post('/api/carrier-services/bulk', {
                            integration_id: this.integrationId,
                            carrier_id: this.selectedCarrier.id,
                            services: this.services.map(service => service.value),
                            carrier_name: this.selectedCarrier.name,
                            all_carriers: this.carriers,
                            liverates_carrier_group_id: this.carrierGroupId,
                        })
                        .then(({ data }) => {
                            EventBus.$emit('show-success', "Successfully Added new carrier services")
                            this.fetchGroupCarrierServices()
                        })
                        .catch(err => {
                            EventBus.$emit('show-error', err)
                        })
                }
                else {
                    this.$http
                        .post('/api/carrier-services/all', {
                            integration_id: this.integrationId,
                            all_carriers: this.carriers,
                            liverates_carrier_group_id: this.carrierGroupId,
                        })
                        .then(({ data }) => {
                            EventBus.$emit('show-success', "Successfully Added ALL Carrier & Services")
                            this.fetchGroupCarrierServices()
                        })
                        .catch(err => {
                            EventBus.$emit('show-error', err)
                        })
                }
            }

            this.selectedCarrier = null
            this.selectedService = null
        },

        onDelete(index) {
            this.$refs.modal.onShow(
                'Delete Confirmation',
                'Are you sure you want to delete this carrier service?',
                () => { this.onDeleteConfirm(index) }
            );
        },

        onDeleteConfirm(index) {
            let carrier = this.carrierServices[index];
            this.carrierServices.splice(index, 1);

            this.$http
                .post('/api/carrier-services/delete/' + carrier.id, { integration_id: this.integrationId })
                .then(({ data }) => {
                    EventBus.$emit('show-success', "Successfully Deleted carrier service")
                })
                .catch(err => {
                    EventBus.$emit('show-error', err);
                });
        },

        async onRefresh() {
            try {
                this.isRefreshing = true
                await this.$http.post('/api/machship/refresh', { integration_id : this.integrationId })
                this.fetchCarriers()
                EventBus.$emit('show-success', "Successfully refresh carrier and service")
            } catch (err) {
                EventBus.$emit('show-error', err)
            }


            this.isRefreshing = false
        },

        onDeleteByCarrierGroup() {
            this.$refs.modal.onShow(
                'Delete Confirmation',
                'Are you sure you want to delete all of the services of this Carrier Group?',
                this.onDeleteByCarrierGroupConfirm
            );
        },

        onDeleteByCarrierGroupConfirm() {
            this.$http
                .post(`/api/carrier-services/group-delete/${this.carrierGroupId}/${this.selectedCarrier.id}`, { integration_id: this.integrationId })
                .then((response) => {
                    if (!response.data) {
                        EventBus.$emit('show-error', "Nothing to delete.")
                    } else {
                        this.fetchGroupCarrierServices();
                        EventBus.$emit('show-success', "Successfully deleted Carrier and Services.")
                    }

                    this.selectedCarrier = [];
                })
                .catch((error) => {
                    EventBus.$emit('show-error', error.message);
                });
        }
    }
}
</script>